export const VENUS_MEDIUM_URL = 'https://medium.com/@umiswapweb3';
export const VENUS_DISCORD_URL = 'https://discord.com/invite/vgkePr783P';
export const VENUS_TWITTER_URL = 'https://twitter.com/umiswap';
export const VENUS_GITHUB_URL = 'https://github.com/VenusProtocol/';
